module.exports = __webpack_public_path__ + "img/u93.668fa536.png";